import React from 'react';
import '../styles/IDCardPopup.css'; 
import closeIconImage from "../images/popup_close.png";

const IDCardPopup = ({ open, idCardUrl, onClose }) => {
  if (!open) return null; // Don't render the popup if not open

  return (
    <div className="id-card-popup-overlay">
      <div className="id-card-popup-content">
        <div className='close-button'><img src={closeIconImage} alt="Close" onClick={onClose} className="close-icon" aria-label="Close dialog"/></div>
        <img src={idCardUrl} alt="ID Card" className="id-card-popup-image" />
      </div>
    </div>
  );
};

export default IDCardPopup;
